import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { ProductPage } from '~/components/ProductPage/OfficeTableProductPage'
import { OfficeTableConfiguration } from '~/components/ProductPage/productTypes/officeTable'

export default function OfficeTableConfiguratorPage() {
  return (
    <ProductPageLayout showDescription={false}>
      <ProductPage components={OfficeTableConfiguration} name="Masă de birou" />
    </ProductPageLayout>
  )
}
